export const ROUTE_CONSTANTS = {
    LOGIN_SCREEN: '/login',
    ROOT: '/'
}